import {setDefaultOptions} from 'date-fns';
import {cs} from 'date-fns/locale';

export default defineNuxtPlugin(() => {
	setDefaultOptions({locale: cs});
});
